import * as React from "react";

function SvgColumnIcon(props) {
  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" {...props}><path d="M18.3 0H1.8C.8 0 0 .8 0 1.8v16.4c0 1 .8 1.8 1.8 1.8h16.4c1 0 1.8-.8 1.8-1.8V1.8c.1-1-.7-1.8-1.7-1.8zM6.1 18.6H1.8c-.2 0-.3-.1-.3-.3V1.8c0-.2.1-.3.3-.3h4.3v17.1zm12.2 0h-4.5V1.5h4.4c.2 0 .3.1.3.3l.1 16.5c0 .2-.1.3-.3.3z" /></svg>;
}

export default SvgColumnIcon;